import * as React from "react";
const SvgMinus = props => <svg width={8} height={2} viewBox="0 0 8 2" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M7.88911 1.56142H3.81503H0.111328V0.438971H3.44466L0.296513 0.464482L7.88911 0.438958V1.56142Z" fill="#313131" /></svg>;
export default SvgMinus;